import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import '../App.css';
import { GooglePlayButton, AppStoreButton } from './StoreButtons';
import QRCode from "react-qr-code";

import './RecipeDetailPage.css';

const RecipeDetailPage = () => {
    const { recipeId, token } = useParams();
    const [loading, setLoading] = useState(true);

    // Differentiate between ID-based link and Token-based share link
    // URL path: /recipe/:recipeId OR /share/:token
    const identifier = token || recipeId;
    const isToken = !!token;

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const environment = queryParams.get('environment');

    // Determine scheme: default 'nibbletapp', override to 'nibbletapp-debug' if environment=development
    // Also support checking process.env for build-time configuration if needed, but query param takes precedence
    // const scheme = environment === 'development' || process.env.NODE_ENV === 'development'
    //     ? 'nibbletapp-debug'
    //     : 'nibbletapp';

    const scheme = "nibbletapp"

    // Deep link URL construction
    const appDeepLink = isToken
        ? `${scheme}://share/${identifier}`
        : `${scheme}://recipe/${identifier}`;

    useEffect(() => {
        // Attempt to redirect to app
        window.location.href = appDeepLink;
        setLoading(false);
    }, [appDeepLink]);

    return (
        <div className="main-content recipe-detail-container">
            <div className="hero">
                <h1 className="hero-title">View this recipe in Nibblet</h1>

                <div className="recipe-preview-card">
                    <div style={{ background: 'white', padding: '16px', borderRadius: '16px', display: 'inline-block' }}>
                        <QRCode
                            value={appDeepLink}
                            size={256}
                            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                            viewBox={`0 0 256 256`}
                        />
                    </div>
                    <p className="recipe-preview-text" style={{ marginTop: '20px' }}>
                        Scan to open the recipe in the Nibblet app
                    </p>
                </div>

                <div className="download-section recipe-download-section">
                    <a href={appDeepLink} className="download-btn open-app-btn">
                        Open in App
                    </a>

                    <p className="no-app-text">Don't have the app?</p>

                    <div className="store-buttons-container">
                        <AppStoreButton />
                        <GooglePlayButton />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RecipeDetailPage;
